import {
  EL_AGENCIES_READ,
  EL_CATEGORIES_READ,
  EL_CATEGORY_SET,
  EL_CODELIST_COUNT_READ,
  EL_CODELIST_ITEMS_READ,
  EL_CONNECTION_ENDPOINT_PING,
  EL_CONNECTION_ENDPOINT_SET,
  EL_CSV_COUNT_AND_ITEMS_READ,
  EL_CSV_HEADER_READ,
  EL_STRUCTURE_CSV_HEADER_READ,
  EL_DATA_CREATE_SUBMIT,
  EL_DATA_IMPORT_STATUS_GET,
  EL_DATA_UPDATE_SUBMIT,
  EL_DST_DATAFLOW_FORM_CHANGE,
  EL_DST_DATAFLOW_SET,
  EL_DST_DATAFLOW_UNSET,
  EL_DST_DATAFLOWS_READ,
  EL_FILTER_MODE_ADVANCED_MODE_CHANGE,
  EL_FILTER_MODE_ADVANCED_VALUES_CHANGE,
  EL_FILTER_MODE_CHANGE,
  EL_FILTER_MODE_SIMPLE_BLOCK_ADD,
  EL_FILTER_MODE_SIMPLE_BLOCK_DELETE,
  EL_FILTER_MODE_SIMPLE_CONDITION_ADD,
  EL_FILTER_MODE_SIMPLE_CONDITION_DELETE,
  EL_FILTER_MODE_SIMPLE_VALUES_CHANGE,
  EL_FILTER_MODE_SIMPLE_VALUES_READ,
  EL_FILTER_MODE_SIMPLE_VALUES_RESET,
  EL_FILTER_RESET,
  EL_METADATA_REPORT_HIDE,
  EL_METADATA_SUBMIT,
  EL_PUBLISH_DATAFLOW_CHANGE,
  EL_RESET,
  EL_SOURCE_FORMAT_SET,
  EL_SRC_DATAFLOW_DSD_READ,
  EL_SRC_DATAFLOW_SET,
  EL_SRC_DATAFLOW_UNSET,
  EL_SRC_DATAFLOWS_READ,
  EL_SRC_FILE_CSV_UPLOAD,
  EL_SRC_FILE_EXCEL_CONVERT,
  EL_SRC_FILE_EXCEL_UPLOAD,
  EL_SRC_FILE_FORM_CHANGE,
  EL_SRC_FILE_PREVIEW_HIDE,
  EL_SRC_FILE_PREVIEW_READ,
  EL_SRC_FILE_PREVIEW_SHOW,
  EL_SRC_TABLE_SET,
  EL_SRC_TABLES_READ,
  EL_STEP_SET,
  EL_TRANSCODE_DATAFLOW_CHANGE,
  EL_STRUCTURE_COLUMN_TYPE_SET,
  EL_DIMENSIONS_COLUMNS_SET,
  EL_CODELISTS_READ,
  EL_ATTRIBUTES_COLUMNS_SET,
  EL_SEMANTIC_COLUMNS_SET,
  EL_CONCEPT_SCHEMES_READ,
  EL_CONCEPTS_READ,
  EL_METADATA_CSV_PRELOAD,
  EL_LOAD_TABLE_SET_EXISTS,
  EL_CREATE_ARTEFACTS,
  EL_CREATE_DSD,
  EL_DATA_CREATE_FROM_FILE_SUBMIT,
  EL_DATA_CREATE_FROM_DB_SUBMIT,
  EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE,
  EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE,
  EL_DATA_UPDATE_FROM_FILE_SUBMIT,
  EL_DATA_UPDATE_FROM_DB_SUBMIT,
  EL_CONCEPTS_CLEAR,
  EL_DELETE_CREATED_ARTEFACTS,
  EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT,
} from "./actions";
import _ from "lodash";
import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../middlewares/api/actions";
import {getCurrentUserPermissions} from "../../middlewares/current-user-permissions/middleware";
import {DCS_ORDERED_TREE_ROOT, getCubesTree} from "../../utils/treeBuilders";
import {
  getFilteredTreeWithPaths,
  getMappedTree,
  getMaxTreeDepth,
  getNodes,
  getTreeFromArray,
  UNCATEGORIZED_CATEGORY_CODE
} from "../../utils/tree";
import {
  CODELIST_ORDER_ANNOTATION_KEY,
  FILTER_MODE_IN,
  getArtefactFromSdmxJsonStructure,
  getArtefactTripletFromString,
  getDsdFromSdmxJsonStructure,
  getItemSchemeFromSdmxJsonFactory,
  getSdmxStructuresFromSdmxJson,
  getStringFromArtefactTriplet,
  getUrnFromArtefactTriplet,
  SDMX_JSON_CODELIST_ITEMS_KEY,
  SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY,
  SDMX_JSON_DSD_URN_NAMESPACE
} from "../../utils/sdmxJson";
import {getCurrentNodeConfig} from "../../middlewares/current-node-config/middleware";
import {getNormalizedColumnName} from "../../utils/normalizers";
import {getTreeFilterStrFromObj} from "../tree-filter/utils";
import {QUERY_FORM_FILTER_MODE_TREE} from "../query-form";
import {EL_COL_TYPE_DIMENSION, EL_COL_TYPE_MEASURE, EL_COL_TYPE_TRANSLATION, EL_DIMENSION_ROLE_FREQUENCY, EL_DIMENSION_ROLE_TERRITORY, EL_DIMENSION_ROLE_TIME, EL_SEMANTIC_CONCEPT_EXISTING, EL_SEMANTIC_CONCEPT_NEW, EL_SOURCE_FORMAT_SDMX_EP, EL_STEP_DATA, newMapping} from "./constants";
import {DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD} from "../../scenes/meta-manager/dataflows/reducer";
import {getFilterStrFromObj} from "../../utils/filter";
import { assignTranslation, clearTranslatedColumn, clearTranslationsOfCurrentColumn, columnCanBeTranslated } from "./structure-step/utils";
import { isIDValidWithHelp, isVersionValidWithHelp } from "../../utils/artefactValidators";
import { EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT, EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD, EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL, EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE, EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL, EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT, EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ, EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT, EL_MAPPING_FILE_MAPPING_READ, EL_MAPPING_RESET_MAPPING } from "./mapping-step/actions";
import { createMappingComponents, mappingIsValid } from "./mapping-step/utils";
import { CUBE_COMPONENT_TYPE_ATTRIBUTE, CUBE_COMPONENT_TYPE_DIMENSION, CUBE_COMPONENT_TYPE_MEASURE, CUBE_COMPONENT_TYPE_TIME_DIMENSION } from "./mapping-step/constants";
import codelistDetailModalReducer from "../../redux-components/redux-codelist-detail-modal/reducer";
import { reuseInReducer, reuseReducer } from "../../utils/reduxReuse";

const initialStateStepData = {
  categoryTree: null,
  forbiddenCategoriesCodes: null,
  agencies: null,
  dstDataflow: null,
  dstDataflows: null,
  category: null
};


const initialStateStepConnection = {
  sourceFormat: EL_SOURCE_FORMAT_SDMX_EP,
  connectionEndpointId: null,
  isConnectionEndpointAvailable: false,
  srcDataflows: null,
  srcDataflow: null,
  srcFileRowsVisible: false,
  srcFileRows: null,
  srcTables: null,
  srcTable: null,
  srcFile: {
    separator: ";"
  }
};

const initialStateStepFilter = {
  dsdColumns: null,
  filterMode: QUERY_FORM_FILTER_MODE_TREE,
  filter: [],
  treeFilter: {},
  filterStr: ""
};

const initialStateStepStructure = {
  structureColumns: null,
};

const initialStateStepDimensions = {
  structureCodelists: null,
};

const initialStateStepSemantic = {
  structureConceptSchemes:null,
  structureConcepts:null  
};


const initialStateMapping = {
  mappings:null,
  csvHeader: null,
  currentMapping: newMapping,
  currentMappingIsValid: false,
  cube: null,
  components: [],
  selectedColumnName: null,
  selectedCubeComponentCode: null,
  selectedComponent: null,
  shouldVerifyMapping: false
};

const initialStateStepLoad = {
  isMetadataImportReportVisible: false,
  metadataImportReport: null,
  isDataImportPending: false,
  dataImportReport: null,
  dataImportStatus: null,
  publishDf: false,
  transcodeDf: true,
  loadTableExists: false,
  createdCodelists: null,
  conceptSchemaDefinition: null,
  artefactsCreated: false,
  dsdTriplet: null,
  toDeleteCodelists: null,
  toDeleteConceptSchema: null,
  hasToDeleteArtefacts: false,
};

const deleteArtefactsInitialState = {
  artefactsCreated: false,
  createdCodelists: null,
  conceptSchemaDefinition: null,
  toDeleteCodelists: null,
  toDeleteConceptSchema: null,
  hasToDeleteArtefacts: false,
}

const isImportStatusWithError = steps => !steps || (steps.length === 1 && steps[0] === "NOT_STARTED_OR_ALREADY_COMPLETED");

const easyLoadingReducer = (
  state = {
    step: EL_STEP_DATA,
    astTerritorialCodelist: null,
    astTerritoryConceptScheme: null,
    astTerritoryConcept: null,
    ...initialStateStepData,
    ...initialStateStepConnection,
    ...initialStateStepFilter,
    ...initialStateStepStructure,
    ...initialStateStepDimensions,    
    ...initialStateStepSemantic,
    ...initialStateMapping,
    ...initialStateStepLoad,    
  },
  action
) => {
  switch (action.type) {
    case EL_STEP_SET:
      return {
        ...state,
        step: action.step
      };
    case EL_DST_DATAFLOW_FORM_CHANGE:
      return {
        ...state,
        dstDataflow: _.merge(state.dstDataflow, action.fields)
      };
    case EL_CATEGORY_SET:
      return {
        ...state,
        category: action.category
      };
    case EL_DST_DATAFLOW_SET:
      return {
        ...state,
        ...initialStateStepData,
        ...initialStateStepConnection,
        ...initialStateStepFilter,
        ...initialStateStepStructure,
        ...initialStateStepDimensions,    
        ...initialStateStepSemantic,
        ...initialStateMapping,
        ...initialStateStepLoad,
        dstDataflows: null,
        dstDataflow: action.dataflow
      };
    case EL_DST_DATAFLOW_UNSET:
      return {
        ...state,
        dstDataflow: null,
        ...initialStateStepData,
        ...initialStateStepConnection,
        ...initialStateStepFilter,
        ...initialStateStepStructure,
        ...initialStateStepDimensions,    
        ...initialStateStepSemantic,
        ...initialStateMapping,
        ...initialStateStepLoad
      };
    case EL_SOURCE_FORMAT_SET:
      return {
        ...state,
        ...initialStateStepConnection,   
        sourceFormat: action.format,
        ...initialStateStepFilter,
        ...initialStateStepStructure,
        ...initialStateStepDimensions,
        ...initialStateStepSemantic,
        ...initialStateMapping,
        ...initialStateStepLoad,        
      };
    case EL_SRC_FILE_FORM_CHANGE: {
      const stateSrcFile = _.clone(state.srcFile);
      return {
        ...state,
        srcFile: {
          ..._.mergeWith(stateSrcFile, action.fields),
          csvPath: null
        }
      };         
    }
    case EL_SRC_FILE_PREVIEW_SHOW:
      return {
        ...state,
        srcFileRowsVisible: true
      }
    case EL_SRC_FILE_PREVIEW_HIDE:
      return {
        ...state,
        srcFileRowsVisible: false,
        srcFileRows: null
      }
    case EL_CONNECTION_ENDPOINT_SET:
      return {
        ...state,
        connectionEndpointId: action.endpointId,
        isConnectionEndpointAvailable: false,
        srcDataflow: null,
        ...initialStateStepFilter,
        ...initialStateStepLoad
      };
    case EL_SRC_DATAFLOW_SET:
      return {
        ...state,
        srcDataflows: null,
        srcDataflow: action.dataflow
      };
    case EL_SRC_DATAFLOW_UNSET:
      return {
        ...state,
        srcDataflow: null,
        ...initialStateStepFilter,
        ...initialStateStepLoad
      };
    case EL_FILTER_MODE_CHANGE:
      return {
        ...state,
        filterMode: action.mode,
        filter: [],
        treeFilter: {},
        filterStr: ""
      };
    case EL_FILTER_MODE_ADVANCED_VALUES_CHANGE: {

      const treeFilter = _.cloneDeep(state.treeFilter);

      const columnName = getNormalizedColumnName(action.colName);
      treeFilter[columnName] = {
        mode: treeFilter[columnName] && treeFilter[columnName].mode
          ? treeFilter[columnName].mode
          : FILTER_MODE_IN,
        values: action.values
      };

      const colNames = state.dsdColumns.map(({name}) => name);

      const colIndex = colNames.indexOf(action.colName);

      const subsequentColNames = colNames.splice(colIndex + 1);

      // delete filters for subsequent cols
      subsequentColNames.forEach(name => {
        delete treeFilter[getNormalizedColumnName(name)];
      });

      const newDsdColumns = state.dsdColumns.map(col => subsequentColNames.includes(col.id)
        ? ({
          ...col,
          valuesCount: null,
          filteredValues: null,
          codelistCount: null,
          filteredCodelistTree: null,
          filteredCodelistTreeMaxDepth: null
        })
        : col
      );

      return {
        ...state,
        dsdColumns: newDsdColumns,
        treeFilter: treeFilter,
        filterStr: getTreeFilterStrFromObj(treeFilter, (state.dsdColumns || []).map(({name}) => name)),
        ...initialStateStepLoad
      };
    }
    case EL_FILTER_MODE_ADVANCED_MODE_CHANGE: {

      const treeFilter = _.cloneDeep(state.treeFilter);

      const columnName = getNormalizedColumnName(action.colName);
      treeFilter[columnName] = {
        mode: action.mode,
        values: treeFilter[action.colName] && treeFilter[action.colName].values
          ? treeFilter[action.colName].values
          : []
      };

      const colNames = state.dsdColumns.map(({name}) => name);

      const colIndex = colNames.indexOf(action.colName);

      const subsequentColNames = colNames.splice(colIndex + 1);

      // delete filters for subsequent cols
      subsequentColNames.forEach(name => {
        delete treeFilter[getNormalizedColumnName(name)];
      });

      const newDsdColumns = state.dsdColumns.map(col => subsequentColNames.includes(col.id)
        ? ({
          ...col,
          valuesCount: null,
          filteredValues: null,
          codelistCount: null,
          filteredCodelistTree: null,
          filteredCodelistTreeMaxDepth: null
        })
        : col
      );

      return {
        ...state,
        dsdColumns: newDsdColumns,
        treeFilter: treeFilter,
        filterStr: getTreeFilterStrFromObj(treeFilter, (state.dsdColumns || []).map(({name}) => name)),
      };
    }
    case EL_FILTER_MODE_SIMPLE_BLOCK_ADD: {
      const newBlock = {
        column: null,
        logicalOperator: 'OR',
        conditions: null
      };
      const newFilter = state.filter !== null
        ? [...state.filter, newBlock]
        : [newBlock]
      return {
        ...state,
        filter: newFilter,
        filterStr: getFilterStrFromObj(newFilter, (state.dsdColumns || []))
      };
    }
    case EL_FILTER_MODE_SIMPLE_BLOCK_DELETE: {
      const newFilter = _.cloneDeep(state.filter);
      newFilter.splice(action.blockIndex, 1);
      return {
        ...state,
        filter: newFilter,
        filterStr: getFilterStrFromObj(newFilter, (state.dsdColumns || []))
      };
    }
    case EL_FILTER_MODE_SIMPLE_CONDITION_ADD: {
      const newFilter = _.cloneDeep(state.filter);
      const newCondition = {
        comparisonOperator: null,
        value: null
      };
      if (newFilter[action.blockIndex].conditions !== null) {
        newFilter[action.blockIndex].conditions.push(newCondition);
      } else {
        newFilter[action.blockIndex].conditions = [newCondition];
      }
      return {
        ...state,
        filter: newFilter,
        filterStr: getFilterStrFromObj(newFilter, (state.dsdColumns || []))
      };
    }
    case EL_FILTER_MODE_SIMPLE_CONDITION_DELETE: {
      const newFilter = _.cloneDeep(state.filter);
      newFilter[action.blockIndex].conditions.splice(action.conditionIndex, 1);
      return {
        ...state,
        filter: newFilter,
        filterStr: getFilterStrFromObj(newFilter, (state.dsdColumns || []))
      };
    }
    case EL_FILTER_MODE_SIMPLE_VALUES_CHANGE: {
      let newFilter = _.cloneDeep(state.filter);
      if (action.fields.filter.filter(block => block.column !== undefined).length > 0) {
        action.fields.filter = action.fields.filter.map(block => ({
          ...block,
          conditions: null
        }));
      }
      newFilter = _.merge(newFilter, action.fields.filter);
      return {
        ...state,
        filter: newFilter,
        filterStr: getFilterStrFromObj(newFilter, (state.dsdColumns || []))
      };
    }
    case EL_FILTER_MODE_SIMPLE_VALUES_RESET: {
      const newDsdColumns = state.dsdColumns.map(col => col.id === action.dimensionId
        ? ({
          ...col,
          valuesCount: null,
          values: null
        })
        : col
      );

      return {
        ...state,
        dsdColumns: newDsdColumns
      };
    }
    case EL_FILTER_RESET:
      return {
        ...state,
        filter: [],
        treeFilter: {},
        filterStr: "",
      };
    case EL_STRUCTURE_COLUMN_TYPE_SET: {
      const columns = _.cloneDeep(state.structureColumns) || [];
      const column = columns.find(c => c.id === action.columnId);

      if (!column) {
        return {
          ...state,
          structureColumns: columns
        };
      }      

      column.type = action.columnType;
      column.translationDefinition.transColId = action.transColId; 
      column.translationDefinition.langCode = action.langCode;   
      column.dimensionDefinition.role = null;
      column.dimensionDefinition.association = null;
      
      if (!columnCanBeTranslated(column)) {
        clearTranslationsOfCurrentColumn(columns, column) ;       
      }

      clearTranslatedColumn(columns, column);

      if (column.type === EL_COL_TYPE_TRANSLATION && column.translationDefinition.transColId 
        && column.translationDefinition.langCode) {
          assignTranslation(columns, column);
      }

      if (column.type !== EL_COL_TYPE_TRANSLATION) {
        column.translations = null;
        column.translationDefinition.transColId = null;
        column.translationDefinition.langCode = null;        
      }

      return {
        ...state,
        structureColumns: columns
      };
    }
    case EL_DIMENSIONS_COLUMNS_SET: {
      const columns = _.cloneDeep(state.structureColumns) || [];
      const column = columns.find(c => c.id === action.columnId);
      if (column) {
        column.dimensionDefinition.role = action.role;
        column.dimensionDefinition.association = action.association;
        if (column.dimensionDefinition.role === EL_DIMENSION_ROLE_TIME) {
          column.dimensionDefinition.association = null;
        }                          
      }
      return {
        ...state,    
        ...initialStateStepSemantic,
        ...initialStateMapping,
        ...initialStateStepLoad,
        structureColumns: columns
      };
    }
    case EL_ATTRIBUTES_COLUMNS_SET: {
      const columns = _.cloneDeep(state.structureColumns) || [];
      const column = columns.find(c => c.id === action.columnId);
      if (column) {
        column.attributeDefinition.refers = action.refers;
        column.attributeDefinition.dimensions = action.dimensions;
        column.attributeDefinition.association = action.association;                          
      }
      return {
        ...state,    
        ...initialStateStepSemantic,
        ...initialStateMapping,
        ...initialStateStepLoad,
        structureColumns: columns
      };
    }  
    case EL_SEMANTIC_COLUMNS_SET: {
      const columns = _.cloneDeep(state.structureColumns) || [];
      const column = columns.find(c => c.id === action.columnId);
      if (column) {
        column.semanticDefinition.conceptType = action.conceptType;
        if (action.conceptType === EL_SEMANTIC_CONCEPT_NEW) {
          if (action.conceptLang) {  
            column.semanticDefinition.currentLang =  action.conceptLang;          
            column.semanticDefinition.newConcept[action.conceptLang] = action.conceptName || "";
          }
        }
        else {
          column.semanticDefinition.newConcept = {};
        }                
        column.semanticDefinition.conceptSchema = action.conceptSchema;
        column.semanticDefinition.concept = action.concept;                       
      }
      return {
        ...state,
        ...initialStateMapping,
        ...initialStateStepLoad,
        structureColumns: columns
      };
    }
    case EL_LOAD_TABLE_SET_EXISTS:   
      return {
        ...state,
        loadTableExists: action.value
      };  
      
    case EL_CONCEPTS_CLEAR: {
      return {
        ...state,
        structureConcepts: null
      };
    } 

    case EL_CREATE_ARTEFACTS: { 
      return {
        ...state,
        createdCodelists: null,
        conceptSchemaDefinition: null,
        artefactsCreated: true,
        metadataImportReport: []
      }
    }
    case EL_DELETE_CREATED_ARTEFACTS: {
      return {
        ...state,
        ...deleteArtefactsInitialState,

      }
    }
    case EL_MAPPING_RESET_MAPPING:
      return {
        ...state,
        ...initialStateStepLoad,        
        currentMapping: newMapping,
        currentMappingIsValid: false,
        selectedColumnName: null,
        selectedComponent: null,
        selectedCubeComponentCode: null,
        components:[]
    };
    case EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT:
      return {
        ...state,
        ...initialStateStepLoad,
        selectedColumnName: action.columnName,
        selectedComponent: null,
      };
    case EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT:
      return {
        ...state,
        ...initialStateStepLoad,
        selectedColumnName: null,
        selectedCubeComponentCode: null,
        selectedComponent: {
          columnName: action.columnName,
          cubeComponentCode: action.cubeComponentCode
        }
      };
    case EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD: {
      const components = [
        {
          columnName: action.columnName,
          cubeComponentCode: action.cubeComponentCode,
          cubeComponentType:
          [
            ...state.cube.components.dimensions,
            ...state.cube.components.timeDimensions,
            ...state.cube.components.attributes,
            ...state.cube.components.measures
          ].filter(comp => comp.Code === action.cubeComponentCode)[0].cubeComponentType
        },
        ...state.components,
      ];
      const isValidMapping = mappingIsValid(components, state.cube.components);
      return {
        ...state,
        ...initialStateStepLoad,
        selectedComponent: {
          columnName: action.columnName,
          cubeComponentCode: action.cubeComponentCode
        },
        selectedColumnName: null,
        selectedCubeComponentCode: null,
        components: components,
        currentMappingIsValid: isValidMapping
      };
    }      
    case EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL: {
      const components = [
        ...state.csvHeader
          .filter(columnNameToBeMapped =>
            state.components
              .map(mappedComponents => mappedComponents.columnName)
              .indexOf(columnNameToBeMapped) < 0)
          .map(columnNameToBeMapped => {
            const relatedCubeComponentCodeArr =
              [
                ...state.cube.components.dimensions,
                ...state.cube.components.timeDimensions,
                ...state.cube.components.attributes,
                ...state.cube.components.measures
              ]
                .filter(cubeComp =>
                  cubeComp.Code === columnNameToBeMapped &&
                  state.components
                    .map(mappedComp => mappedComp.cubeComponentCode)
                    .indexOf(cubeComp.Code) < 0);
            return relatedCubeComponentCodeArr.length > 0
              ? {
                columnName: columnNameToBeMapped,
                cubeComponentCode: relatedCubeComponentCodeArr[0].Code,
                cubeComponentType: relatedCubeComponentCodeArr[0].cubeComponentType
              }
              : null;
          })
          .filter(comp => comp !== null),
        ...state.components
      ];
      const isValidMapping = mappingIsValid(components, state.cube.components);
      return {
        ...state,
        ...initialStateStepLoad,
        components: components,
        selectedColumnName: null,
        selectedCubeComponentCode: null,
        selectedComponent: null,
        currentMappingIsValid: isValidMapping
      };
    }            
    case EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE: {
      const components = state.components
      .filter(({columnName, cubeComponentCode}) =>
        columnName !== action.columnName || cubeComponentCode !== action.cubeComponentCode)
      .map(comp => ({...comp}));
      const isValidMapping = mappingIsValid(components, state.cube.components);
      return {
        ...state,
        ...initialStateStepLoad,
        components:components,
        currentMappingIsValid: isValidMapping         
      };
    }      
    case EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL:
      return {
        ...state,
        ...initialStateStepLoad,
        components: [],
        selectedComponent: null,
        currentMappingIsValid: false
      };
    case EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT:
      return {
        ...state,
        ...initialStateStepLoad,
        selectedCubeComponentCode: action.cubeComponentCode,
        selectedComponent: null
      };
      
    case EL_METADATA_REPORT_HIDE:
      return {
        ...state,
        isMetadataImportReportVisible: false
      };
    case EL_PUBLISH_DATAFLOW_CHANGE:
      return {
        ...state,
        publishDf: action.publishDf
      };
    case EL_TRANSCODE_DATAFLOW_CHANGE:
      return {
        ...state,
        transcodeDf: action.transcodeDf
      };
    case EL_RESET: {
      return {
        ...state,
        step: EL_STEP_DATA,
        astTerritorialCodelist: null,
        astTerritoryConceptScheme: null,
        astTerritoryConcept: null,
        ...initialStateStepData,
        ...initialStateStepConnection,
        ...initialStateStepFilter,
        ...initialStateStepStructure,
        ...initialStateStepDimensions,
        ...initialStateStepSemantic,
        ...initialStateMapping,
        ...initialStateStepLoad
      }
    }
    case REQUEST_START:
      switch (action.label) {
        case EL_CATEGORIES_READ:
          return {
            ...state,
            categoryTree: null,
            forbiddenCategoriesCodes: null
          };
        case EL_CONNECTION_ENDPOINT_PING:
          return {
            ...state,
            isConnectionEndpointAvailable: false
          };
        case EL_SRC_TABLE_SET: {
          return {
            ...state,
            srcTable: action.tableName
          }
        }
        case EL_DATA_CREATE_SUBMIT:
        case EL_DATA_CREATE_FROM_FILE_SUBMIT:
        case EL_DATA_CREATE_FROM_DB_SUBMIT:
        case EL_DATA_UPDATE_SUBMIT:
        case EL_DATA_UPDATE_FROM_FILE_SUBMIT:
        case EL_DATA_UPDATE_FROM_DB_SUBMIT: {
          return {
            ...state,
            isDataImportPending: true,
            dataImportReport: null
          }
        }
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case EL_AGENCIES_READ:
          return {
            ...state,
            agencies: _.pickBy(action.response, (_, agencyID) => !action.allowedAgencies || action.allowedAgencies.includes(agencyID)),
          };
        case EL_CATEGORIES_READ:
          const permissions = getCurrentUserPermissions(action);

          const isAdmin =
            permissions && permissions.rules && permissions.rules.includes("AdminRole");

          const categoriesTree = getCubesTree([], action.response);

          const forbiddenCategoriesCodes =
            getNodes(
              categoriesTree,
              "children",
              ({CatCode}) =>
                !permissions ||
                (CatCode !== undefined && permissions.categories.indexOf(CatCode) < 0)
            )
              .map(({CatCode}) => CatCode)
              .filter(catCode => catCode !== DCS_ORDERED_TREE_ROOT.CatCode && catCode !== UNCATEGORIZED_CATEGORY_CODE);

          const allowedCategoriesTree = getFilteredTreeWithPaths(
            categoriesTree,
            "children",
            obj => obj.Code || isAdmin || !forbiddenCategoriesCodes.includes(obj.CatCode)
          );

          const orderedAllowedCategoriesTree = getMappedTree(
            allowedCategoriesTree,
            "children",
            node => {
              let ordCount = 1;
              return {
                ...node,
                children:
                  node.children
                    ? node.children
                      .sort((a, b) => {
                        if (a.Ord !== undefined && b.Ord !== undefined) {
                          return a.Ord - b.Ord;
                        } else if (a.Ord !== undefined) {
                          return a;
                        } else if (b.Ord !== undefined) {
                          return b;
                        } else {
                          return (a.CatCode || -1) - (b.CatCode || -1);
                        }
                      })
                      .map(c => ({
                        ...c,
                        Ord: c.Ord !== undefined ? String(ordCount++) : undefined
                      }))
                    : node.children
              };
            });

          return {
            ...state,
            categoryTree: orderedAllowedCategoriesTree,
            forbiddenCategoriesCodes: forbiddenCategoriesCodes
          };
        case EL_DST_DATAFLOWS_READ: {

          const ddbDataflowsMap = {};
          (action.response[0] || [])
            .forEach(ddbDataflow => {
              const ddbDataflowTriplet = {
                id: ddbDataflow.ID,
                agencyID: ddbDataflow.Agency,
                version: ddbDataflow.Version,
              }
              ddbDataflowsMap[getStringFromArtefactTriplet(ddbDataflowTriplet)] = ddbDataflow
            });

          const dstDataflows = [];
          (getSdmxStructuresFromSdmxJson(action.response[1]) || [])
            .filter(({structure}) => (
              structure && getUrnFromArtefactTriplet(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD, SDMX_JSON_DSD_URN_NAMESPACE) !== structure)
            )
            .forEach(artefact => {
              const msdbDataflow = getArtefactFromSdmxJsonStructure(artefact);
              const ddbDataflow = ddbDataflowsMap[getStringFromArtefactTriplet(msdbDataflow)];
              if (ddbDataflow !== undefined) {
                dstDataflows.push({
                  ...msdbDataflow,
                  ddbDataflowId: ddbDataflow.IDDataflow,
                  cubeId: ddbDataflow.IDCube
                });
              }
            });

          return {
            ...state,
            dstDataflows: dstDataflows
          };
        }
        case EL_SRC_DATAFLOWS_READ: {
          return {
            ...state,
            srcDataflows: (getSdmxStructuresFromSdmxJson(action.response) || [])
              .filter(({structure}) => (
                structure && getUrnFromArtefactTriplet(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD, SDMX_JSON_DSD_URN_NAMESPACE) !== structure)
              )
              .map(artefact => getArtefactFromSdmxJsonStructure(artefact))
          };
        }
        case EL_CONNECTION_ENDPOINT_PING:
          return {
            ...state,
            isConnectionEndpointAvailable: action.response
          };
        case EL_SRC_FILE_CSV_UPLOAD: {
          return {
            ...state,
            ...initialStateStepFilter,
            ...initialStateStepStructure,
            ...initialStateStepDimensions,
            ...initialStateStepSemantic,
            ...initialStateMapping,
            srcFile: {
              ...state.srcFile,
              filePath: action.response,
              csvPath: action.response,
            }
          }
        }

        case EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE: {
          return {
            ...state,
            srcFile: {
              ...state.srcFile,
              fileAbsolutePath: action.response, 
            }
          }
        }
          
        case EL_SRC_FILE_EXCEL_UPLOAD:
          return {
            ...state,
            srcFile: {
              ...state.srcFile,
              filePath: action.response[0],
              mappingPath: action.response[1],
            }
          }
        case EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE: {
          return {
            ...state,
            srcFile: {
              ...state.srcFile,
              fileAbsolutePath: action.response[0],
              mappingAbsolutePath: action.response[1]
            }
          }
        }
        case EL_SRC_FILE_EXCEL_CONVERT:
          return {
            ...state,
            srcFile: {
              ...state.srcFile,
              csvPath: action.response
            }
          }
        case EL_SRC_FILE_PREVIEW_READ:
          return {
            ...state,
            srcFileRows: action.response
          }
        case EL_SRC_TABLES_READ: {
          return {
            ...state,
            srcFile: {
              ...state.srcFile,
              separator: ";"
            },
            srcTables: action.response
          }
        }
        case EL_SRC_TABLE_SET: {
          return {
            ...state,
            srcFile: {
              ...state.srcFile,
              csvPath: action.response
            }
          }
        }
        case EL_SRC_DATAFLOW_DSD_READ:
          const dsd = getDsdFromSdmxJsonStructure(
            getSdmxStructuresFromSdmxJson(action.response)[0],
            getCurrentNodeConfig(action).annotations
          );
          const columns = (dsd.dimensions || []).map(dim => ({
            id: dim.id,
            name: dim.id,
            isNumeric: false,
            CodelistCode: "CodelistCode",
            valuesCount: null,
            values: null,
            filteredValues: null,
            codelistCount: null,
            codelistTree: null,
            filteredCodelistTree: null,
            filteredCodelistTreeMaxDepth: null,
            hasCodelist: false,
            fetchCodes: null
          }));

          return {
            ...state,
            dsdColumns: columns
          };
        case EL_CODELIST_COUNT_READ: {
          let dsdColumns = _.cloneDeep(state.dsdColumns);
          dsdColumns = dsdColumns.map(col => col.id === action.dimensionId
            ? ({
              ...col,
              codelistCount: Number(action.header["x-total-count"])
            })
            : col
          );

          return {
            ...state,
            dsdColumns: dsdColumns
          };
        }
        case EL_CODELIST_ITEMS_READ: {

          const codelist = getItemSchemeFromSdmxJsonFactory(
            SDMX_JSON_CODELIST_ITEMS_KEY,
            getCurrentNodeConfig(action).annotations,
            CODELIST_ORDER_ANNOTATION_KEY
          )(getSdmxStructuresFromSdmxJson(action.response)[0]);

          let itemsTree;
          try {
            itemsTree = getTreeFromArray((codelist.codes || []), "codes", true);
          } catch (e) {
            itemsTree = null;
          }

          let dsdColumns = _.cloneDeep(state.dsdColumns);

          dsdColumns = dsdColumns.map(col => col.id === action.dimensionId
            ? ({
              ...col,
              filteredValues: getNodes(itemsTree, "codes", () => true).map(({id}) => id),
              filteredCodelistTree: itemsTree,
              filteredCodelistTreeMaxDepth: getMaxTreeDepth(itemsTree, "codes"),
              hasCodesError: !itemsTree
            })
            : col
          );

          return {
            ...state,
            dsdColumns: dsdColumns
          };
        }
        case EL_CSV_HEADER_READ: {
          const columns = (action.response || []).map(dim => ({
            id: dim,
            name: dim,
            isNumeric: false,
            CodelistCode: "",
            valuesCount: null,
            values: null,
            filteredValues: null,
            codelistCount: null,
            codelistTree: null,
            filteredCodelistTree: null,
            filteredCodelistTreeMaxDepth: null,
            hasCodelist: false,
            fetchCodes: null
          }));

          return {
            ...state,
            dsdColumns: columns
          };
        }
        case EL_STRUCTURE_CSV_HEADER_READ : {
          const columns = [];
          const nodeConfig =  getCurrentNodeConfig(action);
          const territorialDimIds = nodeConfig.ast && (nodeConfig.ast.territorialDimIds || []).length > 0 
              ? nodeConfig.ast.territorialDimIds 
              :[];
          const userPermissions = getCurrentUserPermissions(action);
          const canUpdateStructuralMetadata = userPermissions && userPermissions.rules 
            && userPermissions.rules.includes("CanUpdateStructuralMetadata");
          const conceptType = canUpdateStructuralMetadata ? null : EL_SEMANTIC_CONCEPT_EXISTING;          
          (action.response || []).forEach(dim => {
            const dimUpper = dim.toUpperCase();
            const column = {
              id: dim,
              type: null,
              translations: null,
              translationDefinition : {
                langCode: null,
                transColId: null,
              },
              dimensionDefinition : {
                role: null,
                association: null
              },
              attributeDefinition : 
              {
                refers : null,
                association : null,
                dimensions : null
              },
              semanticDefinition: 
              {
                conceptType: conceptType,
                newConcept: {},
                currentLang: action.appLang,
                conceptSchema: null,
                concept: null
              }      
            };
            if (dimUpper === "FREQ") {
              column.type = EL_COL_TYPE_DIMENSION;
              column.dimensionDefinition.role = EL_DIMENSION_ROLE_FREQUENCY;
            } else if (dimUpper === "TIME_PERIOD") {
              column.type = EL_COL_TYPE_DIMENSION;
              column.dimensionDefinition.role = EL_DIMENSION_ROLE_TIME;
            } else if (dimUpper === "OBS_VALUE") {
              column.type = EL_COL_TYPE_MEASURE;
            } else if (territorialDimIds.includes(dim.toUpperCase())) {
              column.type = EL_COL_TYPE_DIMENSION;
              column.dimensionDefinition.role = EL_DIMENSION_ROLE_TERRITORY;
              let dimAssociation = null;
              if (nodeConfig.ast && nodeConfig.ast.astTerritorialCodelist) {
                const codelist = getArtefactTripletFromString(nodeConfig.ast.astTerritorialCodelist);
                if (isIDValidWithHelp(action.t, codelist.id) && 
                    isVersionValidWithHelp(action.t, codelist.version) && 
                    (codelist.agencyID || "").length > 0) {
                      dimAssociation = codelist;
                    }
              }
              column.dimensionDefinition.association = dimAssociation;
            }            
            columns.push(column);
          });          
          return {
            ...state,
            structureColumns: columns
          };
        }
        case EL_CSV_COUNT_AND_ITEMS_READ: {
          const items = (action.response.Data || []).map(item => ({
            id: item[action.dimensionId],
            name: item[action.dimensionId]
          }));

          const newDsdColumns = state.dsdColumns.map(col => col.id === action.dimensionId
            ? ({
              ...col,
              valuesCount: action.response.Count,
              filteredValues: items.map(({id}) => id),
              codelistCount: action.response.Count,
              filteredCodelistTree: items,
              filteredCodelistTreeMaxDepth: 1
            })
            : col
          );

          return {
            ...state,
            dsdColumns: newDsdColumns
          };
        }
        case EL_CODELISTS_READ:
          return {
            ...state,
            structureCodelists:
              (getSdmxStructuresFromSdmxJson(action.response) || []).map(artefact => getArtefactFromSdmxJsonStructure(artefact))
        }
        case EL_CONCEPT_SCHEMES_READ:
          return {
            ...state,
            structureConceptSchemes: (getSdmxStructuresFromSdmxJson(action.response) || []).map(artefact => getArtefactFromSdmxJsonStructure(artefact))
        };
        case EL_CONCEPTS_READ: {
          return {
            ...state,
            structureConcepts: 
              (getItemSchemeFromSdmxJsonFactory(SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY)(getSdmxStructuresFromSdmxJson(action.response)[0])).concepts
          };
        }        
        case EL_FILTER_MODE_SIMPLE_VALUES_READ: {
          const newDsdColumns = state.dsdColumns.map(col => col.id === action.dimensionId
            ? ({
              ...col,
              valuesCount: action.response.Count,
              values: action.response.Data
            })
            : col
          );

          return {
            ...state,
            dsdColumns: newDsdColumns
          };
        }
        case EL_METADATA_SUBMIT: {
          return {
            ...state,
            isMetadataImportReportVisible: true,
            metadataImportReport: action.response.itemsMessage
          }
        }
        case EL_METADATA_CSV_PRELOAD: {
          return {
            ...state,
            srcTable: action.response,
            loadTableExists: true
          }
        }
        case EL_CREATE_ARTEFACTS: {
          const metadataImportReport = [];
          const conceptSchemaDefinition = action.conceptSchemaDefinition;
          const hasConceptSchema = conceptSchemaDefinition !== null;
          let response = action.response;

          if (hasConceptSchema) {
            var csResponse = response.shift();
            if (csResponse) {
              const conceptSchema = conceptSchemaDefinition.conceptSchema;
              metadataImportReport.push({
                "status": "Success",
                "maintainableObject": `ConceptScheme=${conceptSchema.agencyID}:${conceptSchema.id}(${conceptSchema.version})`,
                "isFinal": true,
                "result": "Success",
                "customMessage": null
              });
            }                 
          }

          const codelistColumns = action.codelistColumns || [];
          const hasCodelists = codelistColumns.length > 0;

          let createdCodelists = null;
          if (hasCodelists) {
            createdCodelists = {};
            var dataflowId = state.dstDataflow.id;
            const actionCodelists = response[0] || [];
            for(let i = 0; i < codelistColumns.length; i++) {
              const columnName = codelistColumns[i];
              const createdCodelistName = actionCodelists.find(c => c.startsWith(`${dataflowId}_${columnName}`));
              if (createdCodelistName) {
                createdCodelists[columnName] = createdCodelistName;
                metadataImportReport.push({
                    "status": "Success",
                    "maintainableObject": `CodeList=AST:${createdCodelistName}(1.0)`,
                    "isFinal": true,
                    "result": "Success",
                    "customMessage": null
                });
              }              
            }
          }

          return {
            ...state,
            createdCodelists: createdCodelists,
            conceptSchemaDefinition: conceptSchemaDefinition,
            artefactsCreated: true,
            metadataImportReport: metadataImportReport,
          }
        }
        case EL_DELETE_CREATED_ARTEFACTS: {
          return {
            ...state,
            ...deleteArtefactsInitialState,
          }
        }
        case EL_CREATE_DSD: {
          const dsdTriplet = action.dsdTriplet;
          const metadataImportReport = state.metadataImportReport;
          metadataImportReport.push({
            "status": "Success",
            "maintainableObject": `Dsd=${dsdTriplet.agencyID}:${dsdTriplet.id}(${dsdTriplet.version})`,
            "isFinal": true,
            "result": "Success",
            "customMessage": null
          })
          return {
            ...state,
            dsdTriplet: dsdTriplet,
            metadataImportReport: metadataImportReport,
            isMetadataImportReportVisible: true,
            hasToDeleteArtefacts: false,
            toDeleteCodelists: null,
            toDeleteConceptSchema: null,
          }
        }

        case EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ: {
          const csvHeader = action.response[0];
          const mappings = (action.response[1] || []).filter(m => m.IDCube === action.cubeId);
          const responseCube = action.response[2]; 
          const cube = {
            ...responseCube,
            components: {
              dimensions:
                responseCube.Dimensions
                  .filter(dim => !dim.IsTimeSeriesDim)
                  .map(dim => ({
                    ...dim,
                    cubeComponentType: CUBE_COMPONENT_TYPE_DIMENSION
                  })),
              timeDimensions:
                responseCube.Dimensions
                  .filter(dim => dim.IsTimeSeriesDim)
                  .map(dim => ({
                    ...dim,
                    cubeComponentType: CUBE_COMPONENT_TYPE_TIME_DIMENSION
                  })),
              tidAttributes:
                responseCube.Attributes
                  .filter(attr => attr.IsTid)
                  .map(attr => ({
                    ...attr,
                    cubeComponentType: CUBE_COMPONENT_TYPE_ATTRIBUTE
                  })),
              attributes:
                responseCube.Attributes
                  .filter(attr => !attr.IsTid)
                  .map(attr => ({
                    ...attr,
                    cubeComponentType: CUBE_COMPONENT_TYPE_ATTRIBUTE
                  })),
              measures:
                responseCube.Measures
                  .map(measure => ({
                    ...measure,
                    cubeComponentType: CUBE_COMPONENT_TYPE_MEASURE
                  }))
            }
          };
          const shouldVerifyMapping = mappings.length === 1;
          return {
            ...state,
            csvHeader: csvHeader,
            mappings: mappings,
            cube: cube,
            shouldVerifyMapping: shouldVerifyMapping
          };
        }
        case EL_MAPPING_FILE_MAPPING_READ:
          const mapping = action.response;
          const csvHeader = state.csvHeader;
          const cube = state.cube;
          const mappingComponents = createMappingComponents(mapping, csvHeader, cube.components );
          const isValidMapping = mappingIsValid(mappingComponents, cube.components);
          const shouldVerifyMapping = state.shouldVerifyMapping;
          let currentMapping = mapping;
          let components = mappingComponents;

          if (shouldVerifyMapping && !isValidMapping) {
            currentMapping = newMapping;
            components = [];
          }   
        
          return {
            ...state,
            currentMapping: currentMapping,
            components: components,
            shouldVerifyMapping: false,
            currentMappingIsValid: isValidMapping
          }; 
        
        case EL_DATA_CREATE_SUBMIT:
        case EL_DATA_CREATE_FROM_FILE_SUBMIT:
        case EL_DATA_CREATE_FROM_DB_SUBMIT:
        case EL_DATA_UPDATE_SUBMIT:
        case EL_DATA_UPDATE_FROM_FILE_SUBMIT:
        case EL_DATA_UPDATE_FROM_DB_SUBMIT: {
          return {
            ...state,
            isDataImportPending: false,
            dataImportReport: action.response
          }
        }
        case EL_DATA_IMPORT_STATUS_GET: {
          return {
            ...state,
            dataImportStatus: isImportStatusWithError(action.response)
              ? state.dataImportStatus
              : action.response
          }
        }
        case EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT: {
          const codelistResponse = action.response[0];
          let codelist = -1;
          if (((codelistResponse.data || {}).codelists || []).length === 1) {
            codelist = action.codelist; 
          } 

          const conceptResponse = action.response[1];
          let conceptScheme = -1;
          let concept = -1;

          if (((conceptResponse.data || {}).conceptSchemes || []).length === 1) {
            conceptScheme = action.conceptScheme
            const concepts = (getItemSchemeFromSdmxJsonFactory(
              SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY)(getSdmxStructuresFromSdmxJson(conceptResponse)[0])).concepts;
              const requiredConcept = (concepts || []).find(c => c.id === action.concept);
              if (requiredConcept) {
                concept = action.concept;
              }
          } 
          
          return {
            ...state,
            astTerritorialCodelist: codelist,
            astTerritoryConceptScheme: conceptScheme,
            astTerritoryConcept: concept
          };
        }
        
        default:
          return state;
      }
    case REQUEST_ERROR:
      switch (action.label) {
        case EL_SRC_TABLE_SET: {
          return {
            ...state,
            srcTable: null
          }
        }
        case EL_DATA_CREATE_SUBMIT:
        case EL_DATA_CREATE_FROM_FILE_SUBMIT:
        case EL_DATA_CREATE_FROM_DB_SUBMIT:
        case EL_DATA_UPDATE_SUBMIT:
        case EL_DATA_UPDATE_FROM_FILE_SUBMIT:
        case EL_DATA_UPDATE_FROM_DB_SUBMIT: {
          return {
            ...state,
            isDataImportPending: false,
            dataImportStatus: null,            
          };
        }
        case EL_DATA_IMPORT_STATUS_GET: {
          return {
            ...state,
            dataImportStatus: null
          }
        }
        case EL_CREATE_ARTEFACTS:         
          return {
            ...state,            
            hasToDeleteArtefacts: true,
            artefactsCreated: false,
            metadataImportReport: null,
            dsdTriplet: -1
          };
        case EL_DELETE_CREATED_ARTEFACTS: {
          return {
            ...state,
            ...deleteArtefactsInitialState,
          }
        }
        case EL_CREATE_DSD:
          const toDeleteCodelists = _.cloneDeep(state.createdCodelists);
          const toDeleteConceptSchema = _.cloneDeep(state.conceptSchemaDefinition);
          return {
            ...state,
            createdCodelists: null,
            conceptSchemaDefinition: null,
            dsdTriplet: -1,
            toDeleteCodelists: toDeleteCodelists,
            toDeleteConceptSchema: toDeleteConceptSchema,
            hasToDeleteArtefacts: true         
          };
        default:
          return state;
      }
    default:
      return state;
  }
};


export const EL_CODELIST_DETAIL_PREFIX = "EL_CODELIST_DETAIL_PREFIX_";

export default reuseInReducer(easyLoadingReducer, {
  codelistDetail: reuseReducer(codelistDetailModalReducer, EL_CODELIST_DETAIL_PREFIX),
});


// WEBPACK FOOTER //
// ./src/components/easy-loading/reducer.js